import { render, staticRenderFns } from "./SingleImportComponent.vue?vue&type=template&id=594a4ac0&scoped=true"
import script from "./SingleImportComponent.vue?vue&type=script&lang=js"
export * from "./SingleImportComponent.vue?vue&type=script&lang=js"
import style0 from "./SingleImportComponent.vue?vue&type=style&index=0&id=594a4ac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a4ac0",
  null
  
)

export default component.exports